import { COLORS, getRandomHEX } from '@common/utils';

export function getColors(requiredLength: number): string[] {
  const base = [...COLORS];
  const missing = requiredLength - base.length;

  if (missing <= 0) return base.slice(0, requiredLength);

  return base.concat(Array.from({ length: missing }, getRandomHEX));
}
